import { UPDATE_PERMIT_DECREE_MUTATION } from "services/web/api-decree.const";
import type { UpdatePermitDecreeInput } from "@/types/gql/graphql";
import { useTrackedMutation } from "@/hooks/apollo-insights-hooks";

export const usePermitDecree = (refetchDecree: () => void) => {
  const [updatePermitDecree] = useTrackedMutation(UPDATE_PERMIT_DECREE_MUTATION, {
    actionName: "UpdatePermitDecree",
  });

  const updatePermitDecreeCategory = async (input: UpdatePermitDecreeInput) => {
    await updatePermitDecree({
      variables: { updateDecreeInput: input },
      onCompleted: () => {
        refetchDecree();
      },
    });
  };

  return {
    updatePermitDecreeCategory,
  };
};
